










import { Vue, Component } from 'vue-property-decorator';
import Dashboard from '@/pantallas/Peajes/Dashboard/dashboard.vue';

@Component({
  components: { Dashboard },
})
export default class DashboardPantalla extends Vue {}
